/** Parse opaque token from /story/{token} — token lives in URL only for this session. */

const TOKEN_PATTERN = /^[A-Za-z0-9_-]{32,128}$/;

export function parseStoryTokenFromPath(pathname: string): string | null {
  const match = pathname.match(/^\/story\/([^/]+)\/?$/);
  if (!match) return null;
  const raw = decodeURIComponent(match[1]).trim();
  if (!TOKEN_PATTERN.test(raw)) return null;
  return raw;
}
